module.exports = __webpack_public_path__ + "img/Philippines-5.2a929488.jpg";